import { render, staticRenderFns } from "./bookingBulkDataGrid.vue?vue&type=template&id=2cc4f276&"
import script from "./bookingBulkDataGrid.vue?vue&type=script&lang=js&"
export * from "./bookingBulkDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc4f276')) {
      api.createRecord('2cc4f276', component.options)
    } else {
      api.reload('2cc4f276', component.options)
    }
    module.hot.accept("./bookingBulkDataGrid.vue?vue&type=template&id=2cc4f276&", function () {
      api.rerender('2cc4f276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/bookingBulkDataGrid.vue"
export default component.exports